import { Badge } from '@mantine/core';
import type { GetWorkOrdersSingleWorkOrderResponseDto } from '@/generated/api/pacApi.schemas.ts';

type StatusBadgeTheme = {
  color:
    | 'gray'
    | 'blue'
    | 'indigo'
    | 'cyan'
    | 'red'
    | 'pink'
    | 'teal'
    | 'green'
    | 'lime';
  label: string;
};

const STATUS_COLOR_BY_NAME: Record<string, StatusBadgeTheme['color']> = {
  Draft: 'gray',
  Published: 'blue',
  Routed: 'blue',
  Assigned: 'indigo',
  'Start Time Set': 'indigo',
  Confirmed: 'indigo',
  'On My Way': 'cyan',
  'Assigned: At Risk': 'red',
  'Assigned: Cancelled': 'gray',
  'Assigned: Delayed': 'red',
  'Checked In': 'pink',
  'Checked Out': 'pink',
  'On Hold': 'pink',
  'Work Done': 'teal',
  'Work Done: Increase Requested': 'teal',
  Approved: 'green',
  Paid: 'lime',
};

const STATUS_CANONICAL_LABEL_BY_KEY: Record<string, string> = {
  draft: 'Draft',
  published: 'Published',
  routed: 'Routed',
  assigned: 'Assigned',
  'start time set': 'Start Time Set',
  confirmed: 'Confirmed',
  'on my way': 'On My Way',
  'assigned: at risk': 'Assigned: At Risk',
  'assigned: cancelled': 'Assigned: Cancelled',
  'assigned: delayed': 'Assigned: Delayed',
  'checked in': 'Checked In',
  'checked out': 'Checked Out',
  'on hold': 'On Hold',
  'work done': 'Work Done',
  'work done: increase requested': 'Work Done: Increase Requested',
  approved: 'Approved',
  paid: 'Paid',
};

function canonicalizeStatus(statusName: string): string {
  const normalized = statusName.trim().toLowerCase();
  return STATUS_CANONICAL_LABEL_BY_KEY[normalized] ?? statusName.trim();
}

function getStatusBadgeTheme(statusName: string): StatusBadgeTheme {
  const label = canonicalizeStatus(statusName);
  return {
    label,
    color: STATUS_COLOR_BY_NAME[label] ?? 'gray',
  };
}

export default function WorkOrderStatusBadge({
  status,
}: {
  status: GetWorkOrdersSingleWorkOrderResponseDto['status'];
}) {
  const theme = getStatusBadgeTheme(status);

  return (
    <Badge
      size="sm"
      radius="xl"
      variant="light"
      color={theme.color}
      tt="none"
      title={status}
    >
      {theme.label}
    </Badge>
  );
}
